/**
 * Extends generated ordertrackingApi.ts with non-JSON response handling.
 * After regenerating via `pnpm run generate:ordertracking`, verify export endpoint names.
 */
import {
  type ExportOrdersApiArg,
  type ExportOrdersV20260505ApiArg,
  ordertrackingApi,
} from './ordertrackingApi';

ordertrackingApi.injectEndpoints({
  endpoints: (build) => ({
    exportOrdersV20260505: build.mutation<string, ExportOrdersV20260505ApiArg>({
      query: (queryArg) => ({
        url: '/2026-05-05/orders/export',
        method: 'POST',
        body: queryArg.ordersExportV20260505Dto,
        headers: {
          'cs-organization': queryArg['cs-organization'],
        },
        params: {
          includeAutoImportedOrders: queryArg.includeAutoImportedOrders,
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['order-controller'],
    }),
    exportOrders: build.mutation<string, ExportOrdersApiArg>({
      query: (queryArg) => ({
        url: '/2024-06-01/orders/export',
        method: 'POST',
        body: queryArg.ordersListDto,
        headers: {
          'x-bd-organization': queryArg['x-bd-organization'],
        },
        responseHandler: 'text',
      }),
      invalidatesTags: ['order-controller'],
    }),
  }),
  overrideExisting: true,
});

export { ordertrackingApi };
